(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll('.image-products__slider');

    sliders.forEach((slider, index) => {
      const imageProductsSlider = new Swiper(slider, {
        slidesPerView: 1.1,
        centeredSlides: true,
        spaceBetween: 20,
        navigation: {
          nextEl: '.image-products__slider-nav .swiper-button-next',
          prevEl: '.image-products__slider-nav .swiper-button-prev',
        },
        breakpoints: {
          750: {
            slidesPerView: 1.35,
            spaceBetween: 40,
          },
          1200: {
            slidesPerView: 1.35,
            spaceBetween: 80,
          }
        }
      });
    });
  };

  const initSection = () => {
    initSlider();
  };
  if (!window.ImageProductJSLoaded) {
    window.ImageProductJSLoaded = true
    initSection();
  }

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });
})();
